export function filterArray (array1, array2) {
    const filterMe = array1.filter(arr1 => {
        return array2.filter(arr2 => {
            // return arr1.value == arr2 && arr1.value == '';
            return arr1.value == arr2;
        }).length == 0;
    });

    return filterMe;
}
